require('./hireAdvancedInterstitialPromotionView.scss');

// @ vendors
const { connect } = require('react-redux');
const moment = require('moment');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const React = require('react');
const storage = require('utilities/storage');
const { withRouter } = require('react-router-dom');
// @ actions
const promotionsAction = require('actions/promotions');
const advancedInterstitialPromotionsAction = require('actions/advancedInterstitialPromotions');
// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
import { LoadingSection } from 'commonsComponents/loadingSection';
// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const HireAdvancedInterstitialPromotion = require('components/hireAdvancedIntertitialPromotions/hireAdvancedInterstitialPromotion');
const HireAdvInterstitialPromotionError = require('components/hireAdvancedIntertitialPromotions/hireAdvInterstitialPromotionError');
const HireAdvInterstitialPromotionSuccess = require('components/hireAdvancedIntertitialPromotions/hireAdvInterstitialPromotionSuccess');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
// @helpers
const { formatText } = require('core/i18n').i18n;
// utilities
const {
    PROC_HIRE_PROMOTIONS,
    PROC_START,
    recordLinkV2,
    recordProcess,
} = require('utilities/tagging');
//@constants
const {
    ADVANCED_INTERSTITIAL_ERROR_EVENT,
    ADVANCED_INTERSTITIAL_START_EVENT,
    ADVANCED_INTERSTITIAL_SUCCESS_EVENT,
} = require('constants/index');

class HireAdvancedInterstitialPromotionView extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.isReady = this.isReady.bind(this);

    }

    componentDidMount() {
        const { getAdvancedInterstitialPromotions, history, immAdvancedInterstitialPromotions, requestPromotion } = this.props;
        recordProcess(PROC_HIRE_PROMOTIONS, PROC_START);
        if (immAdvancedInterstitialPromotions) {
            const promotionalCode = immAdvancedInterstitialPromotions.getIn(['promotions', 'promoCode']);
            const nid = immAdvancedInterstitialPromotions.getIn(['promotions', 'nid']);
            if (promotionalCode) {
                requestPromotion(promotionalCode);
                !!nid && storage.sessionStorage.set('nid',  nid);
            } else {
                const nid = sessionStorage.getItem('nid');
                getAdvancedInterstitialPromotions(nid, true);
            }
        } else {
            history.push('/myprofile/edit');
        }
    }

    buildContent(promotionalCode) {
        const {
            immAdvancedInterstitialPromotions,
            immPromotions,
        } = this.props
        let stepProcess = ADVANCED_INTERSTITIAL_START_EVENT;
        if(immPromotions.get('setPromotionSuccessful')){
            stepProcess = ADVANCED_INTERSTITIAL_SUCCESS_EVENT;
        } else if(immPromotions.get('settingPromotionError') !== ''){
            stepProcess = ADVANCED_INTERSTITIAL_ERROR_EVENT;
        }
        let customPageDisplayTaggingData = {
            nombrePagina: `perfil/${immAdvancedInterstitialPromotions.getIn(['promotions', 'cmsId'])}`,
            tipoProceso: 'proc-contratar-promocion',
            pasoProceso: stepProcess,
            detalleProceso: immAdvancedInterstitialPromotions.getIn(['promotions', 'cmsId'])
        }
        recordLinkV2(customPageDisplayTaggingData);
        let dataToRender = (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="row no-outside-gutter">
                            <div className="col-xs-8">
                                <HireAdvancedInterstitialPromotion
                                    immAdvancedInterstitialPromotions={immAdvancedInterstitialPromotions}
                                    immPromotions={immPromotions}
                                    onCancel={this.handleCancel}
                                    onFinish={this.handleFinish}
                                />
                            </div>
                            <div className="col-xs-4">
                                <CallMeBack pageTitle={formatText('promotions-titleHeaderView')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (immPromotions.get('setPromotionSuccessful')) {
            const immPromotion = immPromotions.getIn(['byId', promotionalCode]);
            recordLinkV2(customPageDisplayTaggingData);
            dataToRender = (
                <HireAdvInterstitialPromotionSuccess
                    immPromotion={immPromotion}
                    immAdvancedInterstitialPromotions={immAdvancedInterstitialPromotions}
                />
            );
        } else if (immPromotions.get('settingPromotionError') !== '') {
            recordLinkV2(customPageDisplayTaggingData);
            dataToRender = <HireAdvInterstitialPromotionError />;
        }

        return dataToRender;
    }

    handleCancel() {
        this.props.history.push('/myprofile/edit');
    }

    handleFinish(promotionalCode) {
        this.props.setPromotion(promotionalCode);
    }

    isReady() {
        const { immPromotions, immAdvancedInterstitialPromotions } = this.props;
        const immHirePromotions = immAdvancedInterstitialPromotions.get('promotions');
        const promotionalCode = immHirePromotions.get('promoCode');
        const immPromotion = immPromotions.getIn(['byId', promotionalCode]);

        return promotionalCode === '' ||
            immPromotions.get('settingPromotionError') !== '' ||
            (!!immPromotion && !!immPromotion.get('claimedId'));
    }

    isPromotionExpired(immPromotion) {
        let promotionState = false;
        if (immPromotion) {
            const endPromotionDate = moment(immPromotion.get('finish')).add(1, 'd');
            promotionState = moment().isAfter(endPromotionDate);
        }
        return promotionState;
    }

    isPromotionalCodeValid(promotionalCode) {
        const { immPromotions } = this.props;
        const immPromotion = immPromotions.getIn(['byId', promotionalCode]);
        return !this.isPromotionExpired(immPromotion);
    }

    render() {
        const {
            cancelHirePromotion,
            immAdvancedInterstitialPromotions,
            immPromotions,
        } = this.props;
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const titleHeader = formatText('promotions-titleHeaderView');
        let content;
        const promotions = immAdvancedInterstitialPromotions.get('promotions');
        const promotionalCode = promotions.get('promoCode');

        if (immPromotions.get('isFetchingPromotion')) {
            content = <LoadingSection />;
        } else if (immPromotions.get('fetchingPromotionError')) {
            content = <HireAdvInterstitialPromotionError />;
        } else if (immPromotions.get('fetchPromotionSuccess')) {
            if (this.isPromotionalCodeValid(promotionalCode)) {
                content = this.buildContent(promotionalCode);
            } else {
                content = <HireAdvInterstitialPromotionError />;
            }
        }

        const mappingBreadcrumb = [
            {
                text: formatText('profile-titleHeader'),
                url: '/myprofile/edit'
            },
            {
                text: immAdvancedInterstitialPromotions.getIn(['promotions', 'cmsId']),
                url: ''
            }
        ];

        return (
            <section className="hire-advanced-interstitial-promotion-view">
                <OKCover size="small" section="pg" customClass="col-xs-12">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={titleHeader}>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="hire-promotion-view__body">
                    {content}
                </section>
                <PreLeaveModalComponent confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                    onConfirmLeave={cancelHirePromotion}
                />
            </section>
        );
    }
}

HireAdvancedInterstitialPromotionView.propTypes = {
    cancelHirePromotion: PropTypes.func.isRequired,
    getAdvancedInterstitialPromotions: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAdvancedInterstitialPromotions: PropTypes.object.isRequired,
    immPromotions: PropTypes.object.isRequired,
    requestPromotion: PropTypes.func.isRequired,
    setPromotion: PropTypes.func.isRequired,
};
module.exports.constructor = HireAdvancedInterstitialPromotionView;
module.exports.HireAdvancedInterstitialPromotionView = connect(
    state => ({
        immAdvancedInterstitialPromotions: state.advancedInterstitialPromotions,
        immPromotions: state.promotions,
    }), {
        cancelHirePromotion: promotionsAction.cancelHirePromotion,
        getAdvancedInterstitialPromotions: advancedInterstitialPromotionsAction.getAdvancedInterstitialPromotions,
        requestPromotion: promotionsAction.requestPromotion,
        setPromotion: promotionsAction.setPromotion,
    }
)(withRouter(HireAdvancedInterstitialPromotionView));
